import Spinner from "components/UI-lib/Spinner";
import { classNames } from "components/utils";
import { UserContext } from "contexts/UserContext";
import User from "../../entities/User.entity";
import React, { useContext, useEffect, useState } from "react";
import "./styles.scss";
import { Tooltip } from "@mui/material";
import { cx } from "components/Graphs/utils";

interface UsernameDisplayFieldProps {
  userId: string;
  visible?: boolean;
  className?: string;
}

const UsernameDisplayField: React.FC<UsernameDisplayFieldProps> = ({
  userId,
  visible = true,
  className = "",
}) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  const userContext = useContext(UserContext);

  useEffect(() => {
    const loadUser = async () => {
      setLoading(true);
      const user = await userContext.getUser(userId);
      if (user) setUser(user);
      setLoading(false);
    };

    if (visible) loadUser();
  }, [userId, visible]);

  if (loading) {
    return <Spinner type="primary" />;
  }
  return (
    <Tooltip title={`${userId} | ${user?.email}`} placement="top">
      <span className={classNames("UsernameDisplayField", className)}>
        {user ? user?.username : `id:${userId}`}
      </span>
    </Tooltip>
  );
};

interface UsernameDisplayCircleProps {
  userId: string;
  className?: string;
}

export const UsernameDisplayCircle: React.FC<UsernameDisplayCircleProps> = ({
  userId,
  className = "",
}) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  const userContext = useContext(UserContext);

  useEffect(() => {
    const loadUser = async () => {
      setLoading(true);
      const user = await userContext.getUser(userId);
      if (user) setUser(user);
      setLoading(false);
    };
    loadUser();
  }, [userId]);

  if (loading) {
    return <Spinner type="primary" />;
  }
  return (
    <div className="max-w-xs flex items-center text-sm rounded-full p-1">
      <span className="sr-only">Open user menu</span>
      {user?.profilePhotoUrl ? (
        <img
          className="h-8 w-8 rounded-full"
          src={user.profilePhotoUrl}
          alt=""
        />
      ) : (
        <div
          className={cx(
            "h-8 w-8 rounded-full border border-zinc-800 flex items-center justify-center text-white",
            className
          )}
        >
          {user?.name?.[0]?.toUpperCase() || "?"}
        </div>
      )}
    </div>
  );
};

interface EmailDisplayFieldProps {
  userId: string;
  className?: string;
}

export const EmailDisplayField: React.FC<EmailDisplayFieldProps> = ({
  userId,
  className = "",
}) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  const userContext = useContext(UserContext);

  useEffect(() => {
    const loadUser = async () => {
      setLoading(true);
      const user = await userContext.getUser(userId);
      if (user) setUser(user);
      setLoading(false);
    };
    loadUser();
  }, [userId]);

  if (loading) {
    return <Spinner type="primary" />;
  }
  return (
    <span className={classNames("EmailDisplayField", className)}>
      {user ? user?.email : ""}
    </span>
  );
};

export default UsernameDisplayField;
